import axios, { AxiosResponse } from 'axios';

import { StartUpApiResponse, STARTUP_API_ERRORS } from '../types/api/StartApiType';

import { AppDispatch } from '../store/store';
import { setState as setClientId } from '../slice/ClientIdSlice';
import { env_user } from '../conf/environ_user';

// クライアントID発行 API-8001
export const initializeApp = async (dispatch: AppDispatch, clientId: string) => {
    let resultClientId = '';

    // baseURLとヘッダにclient-idを設定
    axios.defaults.baseURL = env_user.baseURL;
    // client-idが取得できていればそのままreturn
    if (clientId) {
        return clientId;
    } else {
        try {
            const result: AxiosResponse<StartUpApiResponse> = await axios.get('/api/startup');
            if (result?.data?.client_id) {
                dispatch(setClientId(result.data.client_id));
                resultClientId = result.data.client_id;
            } else {
                return STARTUP_API_ERRORS.REQUEST_ERROR_8001;
            }
        } catch (error) {
            // リクエストが異常終了
            let error_ret = STARTUP_API_ERRORS.REQUEST_ERROR_8001;
            if (axios.isAxiosError(error)) {
                if (error.response?.status) {
                    // ステータスコードが設定されていた場合、ステータスコードを設定
                    error_ret = STARTUP_API_ERRORS.REQUEST_ERROR_8001_STATUS_CODE.replace(
                        '%1',
                        error.response.status as unknown as string
                    );
                }
            }
            return error_ret;
        }
    }

    return resultClientId;
};
